import React, { useEffect } from "react";
import { Route, useLocation, useNavigate } from "react-router-dom";
import { Wrapper } from "../Components/Utils/roles";

import MainMeeting from "../Views/Web/Meeting/MainMeeting";
import MainMeetingPoints from "../Views/Web/Meeting/meeting-points/MainMeetingPoints";
import MeetingPointsIndex from "../Views/Web/Meeting/meeting-points/list";
import CreateMeetingPoint from "../Views/Web/Meeting/meeting-points/add";
import EditMeetingPoint from "../Views/Web/Meeting/meeting-points/edit";
import ViewMeetingPoint from "../Views/Web/Meeting/meeting-points/view";

import MainParticipants from "../Views/Web/Meeting/participants/MainParticipants";
import ParticipantsIndex from "../Views/Web/Meeting/participants/list";
import CreateParticipant from "../Views/Web/Meeting/participants/add";
import EditParticipant from "../Views/Web/Meeting/participants/edit";
import ViewParticipant from "../Views/Web/Meeting/participants/view";

const MeetingRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      location.pathname === "/meeting" ||
      location.pathname === "/meeting/"
    ) {
      navigate("/meeting/meeting-points");
    }
  }, [location, navigate]);

  return (
    <Route path="meeting" element={<MainMeeting />}>
      {/* Meeting Points Routes */}
      <Route path="meeting-points" element={<MainMeetingPoints />}>
        <Route
          index
          element={
            <Wrapper
              permissionKey={"meeting_points_view"}
              Component={MeetingPointsIndex}
            />
          }
        />
        <Route
          path="create"
          element={
            <Wrapper
              permissionKey={"meeting_points_create"}
              Component={CreateMeetingPoint}
            />
          }
        />
        <Route
          path="edit/:meetingPointId"
          element={
            <Wrapper
              permissionKey={"meeting_points_edit"}
              Component={EditMeetingPoint}
            />
          }
        />
        <Route
          path="view/:meetingPointId"
          element={
            <Wrapper
              permissionKey={"meeting_points_view"}
              Component={ViewMeetingPoint}
            />
          }
        />
      </Route>

      {/* Participants Routes */}
      <Route path="participants" element={<MainParticipants />}>
        <Route
          index
          element={
            <Wrapper
              permissionKey={"meeting_participants_view"}
              Component={ParticipantsIndex}
            />
          }
        />
        <Route
          path="create"
          element={
            <Wrapper
              permissionKey={"meeting_participants_create"}
              Component={CreateParticipant}
            />
          }
        />
        <Route
          path="edit/:participantId"
          element={
            <Wrapper
              permissionKey={"meeting_participants_edit"}
              Component={EditParticipant}
            />
          }
        />
        <Route
          path="view/:participantId"
          element={
            <Wrapper
              permissionKey={"meeting_participants_view"}
              Component={ViewParticipant}
            />
          }
        />
      </Route>
    </Route>
  );
};

export default MeetingRoutes;
